import {
  Component, OnInit, Renderer2, ViewChild, ElementRef, TemplateRef, HostListener
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as data from '../../../../assets/images/workflow/nodes.json';
import { ok } from 'assert';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-workflow-dashboard',
  templateUrl: './workflow-dashboard.component.html',
  styleUrls: ['./workflow-dashboard.component.scss'],
})


export class WorkflowDashboardComponent implements OnInit {
  menuArray: any = [1, 2];
  title = 'demoFlowChart';

  oldClientX: any = 0;
  oldClientY: any = 0;

  screenWidth = '';
  screenHeight = '';

  nodeWidth = 120;
  nodeHeight = 40;
  arrowHead = 5;
  fontSize: any = 18;
  decisionWidth = 70;
  circleWidth = 110;
  circleEventWidth = 80;
  decisionRotate = 45;
  selectImgObj: any;
  freeTextImg: any =
    {
      id: 'arrowToolIcon',
      fillImg: 'url(#arrowToolIcon)',
      imgPath: '/assets/images/workflow/freeText.png',
    }
  arrowToolIcon: any =
    {
      id: 'freeTextImage',
      fillImg: 'url(#freeTextImage)',
      imgPath: '/assets/images/workflow/right-arrow.png',
    }
  nodeToolIcon: any =
    {
      id: 'nodeToolIcon',
      fillImg: 'url(#nodeToolIcon)',
      imgPath: '/assets/images/workflow/nodes.png',
    }

  eventImg: any = [
    {
      id: 'emailImage',
      fillImg: 'url(#emailImage)',
      imgPath: '/assets/images/workflow/mail.png',
    },
    {
      id: 'closeImage',
      fillImg: 'url(#closeImage)',
      imgPath: '/assets/images/workflow/close.png',
    },
    {
      id: 'addImage',
      fillImg: 'url(#addImage)',
      imgPath: '/assets/images/workflow/add.png',
    },
    {
      id: 'watchImage',
      fillImg: 'url(#watchImage)',
      imgPath: '/assets/images/workflow/watch.png',
    },
    {
      id: 'rightArrowImage',
      fillImg: 'url(#rightArrowImage)',
      imgPath: '/assets/images/workflow/rightArrow.png',
    },
    {
      id: 'leftDirectionImage',
      fillImg: 'url(#leftDirectionImage)',
      imgPath: '/assets/images/workflow/leftDirection.png',
    },
    {
      id: 'storageImage',
      fillImg: 'url(#storageImage)',
      imgPath: '/assets/images/workflow/storage.png',
    },
    {
      id: 'adminImage',
      fillImg: 'url(#adminImage)',
      imgPath: '/assets/images/workflow/admin.png',
    },
  ];
  arrows: any = [];
  processNodes: any = [];
  startEndNodes: any = [];
  ioNodes: any = [];
  decisionNodes: any = [];
  startCircleNodes: any = [];
  intermediateCircleNodes: any = [];
  endCircleNodes: any = [];

  rectCallNodes: any = [];
  rectTransactionNodes: any = [];
  rectSubProcessNodes: any = [];

  circleEvents: any = [];
  poolNodes: any = [];
  poolLineNodes: any = [];
  freeTextNodes: any = [];
  freetextVerticalNodes: any = [];
  divStyle: any = '';
  linetoarrowList: any = [];

  isSymbolSelected: boolean = false;
  selectedSymbolType: string = '';
  selectedSymbol: any = 0;

  firstClick: boolean = false;
  lastClick: boolean = false;
  newLineId: any = 0;

  clickedParent: any = {};
  clickedChild: any = {};
  newArrowId: any = 0;
  picketWidth: any = 15;

  nodes: any = (data as any).default;

  arraowSide: any = ''
  isArrowMouseDownClicked: boolean = false;
  newArrowMouseDownStatus: boolean = false;

  isNameDisabled: boolean = true;
  isDisabled: boolean = true;
  isColorDisabled: boolean = true;
  selectedStrokeWidth: any;
  selectedStrokeDash: any;
  selectedSymbolColor: any;
  selectedSymbolFont: any;
  selectedSymbolStrokeColor: any;
  iselectedSymbolArrow: boolean = false;
  selectedSymbolFontSize: any;
  svgName: string = '';
  selectedtextColor: any;
  svgDataList: any[] = [];
  currentWF: any;
  currentDraggableNode: any;
  currentDraggablePoolLinePoint: any;
  isCurrentPoolLineStart: boolean;
  currentDraggableArrowPoint: any;
  currentDraggablePoolNode: any;

  currentDraggableLine: any = {};
  currentDraggableLineObj: any;
  constructor(private renderer: Renderer2, private dialog: MatDialog) { }

  @HostListener('dragstart', ['$event'])
  onDragStart(event: any) {
    this.updateStrokes(false);
    const eifillImg = event.target.getAttribute("eifillImg");
    const eiid = event.target.getAttribute("eiid");
    const eiimgPath = event.target.getAttribute("eiimgPath");
    this.selectImgObj = { fillImg: eifillImg, id: eiid, imgPath: eiimgPath };
    const elementValue = event.target.getAttribute("element");
    this.selectedSymbolType = elementValue;
    this.isSymbolSelected = true;
    if (this.selectedSymbolType == 'poolline' || this.selectedSymbolType == 'arrow') {
      this.updateStrokes(true);
    }
  }

  @HostListener('document:dragover', ['$event'])
  onDragOver(event: any) {
    event.preventDefault();
  }

  @HostListener('drop', ['$event'])
  onDrop(event: any) {
    this.createSelectedSymbol(event);
    return;
  }

  ngOnInit(): void {
    this.screenWidth = '1800px'; // window.innerWidth + 'px';
    this.screenHeight = '800px';//window.innerHeight - 170 + 'px';
    this.divStyle =
      'margin: 5px;overflow-x: scroll;width:' + this.screenWidth + ';';
    this.svgDataList = JSON.parse(sessionStorage.getItem("svgDataList"));
    this.nodes = this.svgDataList ? this.svgDataList[0].value : this.nodes;
    this.currentWF = this.svgDataList ? this.svgDataList[0].name : '';
    this.nodes.map(m => m.pickerStyle = "fill:#0bc928;stroke-width: 1;display:none;");
    this.initMethod();
  }

  initMethod() {
    this.sort_by_key(this.nodes, 'name');
    this.generateNodes();
    this.getClosestPoints();
    this.getPoints();
    this.getLines();
  }

  generateNodes() {
    this.processNodes = this.nodes.filter((m: any) => m.nodeType == 'process');
    this.startEndNodes = this.nodes.filter(
      (m: any) => m.nodeType == 'startend'
    );
    this.ioNodes = this.nodes.filter((m: any) => m.nodeType == 'io');
    this.decisionNodes = this.nodes.filter(
      (m: any) => m.nodeType == 'decision'
    );
    this.startCircleNodes = this.nodes.filter(
      (m: any) => m.nodeType == 'startcircle'
    );
    this.intermediateCircleNodes = this.nodes.filter(
      (m: any) => m.nodeType == 'intermediatecircle'
    );
    this.endCircleNodes = this.nodes.filter(
      (m: any) => m.nodeType == 'endcircle'
    );
    this.rectSubProcessNodes = this.nodes.filter(
      (m: any) => m.nodeType == 'rectsubprocess'
    );
    this.rectCallNodes = this.nodes.filter(
      (m: any) => m.nodeType == 'rectcall'
    );
    this.rectTransactionNodes = this.nodes.filter(
      (m: any) => m.nodeType == 'recttransaction'
    );
    this.circleEvents = this.nodes.filter(
      (m: any) => m.nodeType == 'circleevent'
    );
    this.poolNodes = this.nodes.filter((m: any) => m.nodeType == 'pool');
    this.poolLineNodes = this.nodes.filter(
      (m: any) => m.nodeType == 'poolline'
    );
    this.linetoarrowList = this.nodes.filter(
      (m: any) => m.nodeType == 'linetoarrow'
    );
    this.freeTextNodes = this.nodes.filter(
      (m: any) => m.nodeType == 'freetext'
    );
    this.freetextVerticalNodes = this.nodes.filter(
      (m: any) => m.nodeType == 'freetextvertical'
    );
  }

  AddNewSVG() {
    this.saveSVG();
    this.nodes = [];
    this.initMethod();
  }

  setParentChildNodes(currentnode: any,) {
    if (currentnode) {
      const parents = currentnode.parents;
      const childs = currentnode.childs;
      if (parents && childs) {
        let parentIds: any[] = parents.map((m: any) => m.id);
        let childIds: any[] = childs.map((m: any) => m.id);
        const newChildpoints = this.getNewChildPoints(
          currentnode,
          childIds,
          parentIds
        );
        childs.forEach((child: any) => {
          const points = this.getMinimumDistanceObjectByChildId(
            newChildpoints,
            currentnode.nodeId,
            child.id
          );
          child.x1 = points.x1;
          child.y1 = points.y1;
          child.x2 = points.x2;
          child.y2 = points.y2;
        });

        parentIds.forEach((parentId) => {
          this.nodes
            .filter((node: any) => node.nodeId == parentId)
            .map((m: any) => m.childs)
            .forEach((child: any) => {
              child
                .filter((o: any) => o.id == currentnode.nodeId)
                .forEach((n: any) => {
                  const points = this.getMinimumDistanceObjectByChildId(
                    newChildpoints,
                    n.id,
                    parentId
                  );
                  n.x1 = points.x2;
                  n.y1 = points.y2;
                  n.x2 = points.x1;
                  n.y2 = points.y1;
                });
            });
        });
      }
    }
  }

  getPoints() {
    this.nodes.forEach((currentnode: any) => {
      this.setParentChildNodes(currentnode);
    });
  }

  pickerClick(obj: any) {
    this.nodes.map(m => m.pickerStyle = 'fill:#0bc928;stroke-width: 1;display:none;');
    this.nodes.forEach(m => {
      m.childs.forEach(n => n.pickerStyle = 'fill:#0bc928;stroke-width: 1;display:none;');
    });
    if (obj.nodeId) {
      this.nodes.find(m => m.nodeId == obj.nodeId).pickerStyle = 'fill:#0bc928;stroke-width: 1;';
    } else {
      this.nodes.find(m => m.nodeId == obj.parentId).childs.find(m => m.id == obj.id).pickerStyle = 'fill:#0bc928;stroke-width: 1;';
      this.arrows = [];
      this.nodes.forEach((node: any) => {
        node.childs.forEach((child: any) => {
          this.arrows.push(child);
        });
      });
    }
  }

  rotatePoint(x: any, y: any, centerx: any, centery: any, degrees: any) {
    var newX =
      (x - centerx) * Math.cos((degrees * Math.PI) / 180) -
      (y - centery) * Math.sin((degrees * Math.PI) / 180) +
      centerx;
    var newY =
      (x - centerx) * Math.sin((degrees * Math.PI) / 180) +
      (y - centery) * Math.cos((degrees * Math.PI) / 180) +
      centery;
    return { newX, newY };
  }

  getLines(tmpChild: any = {}) {
    this.arrows = [];
    if (tmpChild.id != undefined) {
      this.nodes.forEach((node: any) => {
        node.childs.forEach((child: any) => {
          child = tmpChild.id == child.id ? tmpChild : child;
          this.arrows.push(child);
        });
      });
    }
    else {
      this.nodes.forEach((node: any) => {
        node.childs.forEach((child: any) => {
          child.parentId = node.nodeId;
          const getMidPoint = this.getMidPoint(child.x1, child.y1, child.x2, child.y2);
          const dragPoint = this.getArrowDraggerPoints(child);
          child.dragPointX1 = dragPoint.newX1;
          child.dragPointY1 = dragPoint.newY1;
          child.dragPointX2 = dragPoint.newX2;
          child.dragPointY2 = dragPoint.newY2;
          child.midX = child.midX == undefined ? getMidPoint.midX : child.midX;
          child.midY = child.midY == undefined ? getMidPoint.midY : child.midY;
          child.pickerStyle = "fill:#0bc928;stroke-width: 1;display:none;";
          child.dValue = "M" + child.x1 + " " + child.y1 + " Q " + child.midX + " " + child.midY + " " + child.x2 + " " + child.y2;
          this.arrows.push(child);
        });
      });
    }
    this.arrows = JSON.parse(JSON.stringify(this.arrows));
  }

  getArrowDraggerPoints(child) {
    const halfPickerWidth = this.picketWidth / 2;
    const lineDistance = this.getDistance(child.x1, child.y1, child.x2, child.y2);
    const n1 = 10;
    const m1 = lineDistance - n1;
    const newX1 = -halfPickerWidth + (m1 * child.x2 + n1 * child.x1) / (m1 + n1);
    const newY1 = -halfPickerWidth + (m1 * child.y2 + n1 * child.y1) / (m1 + n1);
    //-------------
    const n2 = lineDistance - 5;
    const m2 = lineDistance - n2;
    const newX2 = -halfPickerWidth + (m2 * child.x2 + n2 * child.x1) / (m2 + n2);
    const newY2 = -halfPickerWidth + (m2 * child.y2 + n2 * child.y1) / (m2 + n2);
    return { newX1, newY1, newX2, newY2 };
  }

  getMidPoint(x1, y1, x2, y2) {
    const halfPickerWidth = this.picketWidth / 2;
    const lineDistance = this.getDistance(x1, y1, x2, y2);
    const n3 = lineDistance / 2;
    const m3 = lineDistance / 2;
    const midX = -halfPickerWidth + (m3 * x2 + n3 * x1) / (m3 + n3);
    const midY = -halfPickerWidth + (m3 * y2 + n3 * y1) / (m3 + n3);
    return { midX, midY };
  }

  mymousemove($event: any) {
    if (this.currentDraggableLine && this.currentDraggableLine.nodeId) {
      const CNode = this.currentDraggableLineObj;
      this.currentDraggableLine.lineCordinates.x1 = $event.offsetX - CNode.oldX1diff;
      this.currentDraggableLine.lineCordinates.y1 = $event.offsetY - CNode.oldY1diff;
      this.currentDraggableLine.lineCordinates.x2 = $event.offsetX - CNode.oldX2diff;
      this.currentDraggableLine.lineCordinates.y2 = $event.offsetY - CNode.oldY2diff;
    }

    if (this.currentDraggableArrowPoint && this.currentDraggableArrowPoint.id) {
      const halfPickerWidth = this.picketWidth / 2;
      this.currentDraggableArrowPoint.midX = $event.offsetX - halfPickerWidth;
      this.currentDraggableArrowPoint.midY = $event.offsetY - halfPickerWidth;
      this.currentDraggableArrowPoint.dValue = "M" + this.currentDraggableArrowPoint.x1 + " " + this.currentDraggableArrowPoint.y1 + " Q " + this.currentDraggableArrowPoint.midX + " " + this.currentDraggableArrowPoint.midY + " " + this.currentDraggableArrowPoint.x2 + " " + this.currentDraggableArrowPoint.y2;
      this.getLines(this.currentDraggableArrowPoint);
    }

    if (this.currentDraggablePoolLinePoint && this.currentDraggablePoolLinePoint.nodeId) {
      if (this.isCurrentPoolLineStart) {
        this.currentDraggablePoolLinePoint.lineCordinates.x1 += $event.clientX - this.oldClientX;
        this.currentDraggablePoolLinePoint.lineCordinates.y1 += $event.clientY - this.oldClientY;
      } else {
        this.currentDraggablePoolLinePoint.lineCordinates.x2 += $event.clientX - this.oldClientX;
        this.currentDraggablePoolLinePoint.lineCordinates.y2 += $event.clientY - this.oldClientY;
      }

      this.oldClientX = $event.clientX;
      this.oldClientY = $event.clientY;

      this.getClosestPoints();
      this.setParentChildNodes(this.currentDraggablePoolLinePoint);
      this.getLines();
    }

    if (this.currentDraggableNode && this.currentDraggableNode.nodeId) {
      this.currentDraggableNode.nodeX += $event.clientX - this.oldClientX;
      this.currentDraggableNode.nodeY += $event.clientY - this.oldClientY;

      this.oldClientX = $event.clientX;
      this.oldClientY = $event.clientY;

      this.getClosestPoints();
      this.setParentChildNodes(this.currentDraggableNode);
      this.getLines();
    }

    if (this.currentDraggablePoolNode && this.currentDraggablePoolNode.nodeId) {
      this.currentDraggablePoolNode.width += $event.clientX - this.oldClientX;
      this.currentDraggablePoolNode.height += $event.clientY - this.oldClientY;

      this.oldClientX = $event.clientX;
      this.oldClientY = $event.clientY;

      this.getClosestPoints();
      this.setParentChildNodes(this.currentDraggablePoolNode);
      this.getLines();
    }

    if (
      this.clickedParent.nodeId == undefined &&
      this.clickedChild.nodeId == undefined && this.newArrowMouseDownStatus
    ) {
      var lineObj = this.nodes.find(
        (m: any) => m.nodeId == this.newArrowId
      );
      if (lineObj) {
        if (this.arraowSide == 'S') {
          lineObj.lineCordinates.x1 = $event.offsetX;
          lineObj.lineCordinates.y1 = $event.offsetY;
        } else {
          lineObj.lineCordinates.x2 = $event.offsetX;
          lineObj.lineCordinates.y2 = $event.offsetY;
        }
      }
    }

    if (
      this.clickedParent.nodeId != undefined &&
      this.clickedChild.nodeId == undefined
    ) {
      this.nodes.find(
        (m: any) => m.nodeId == this.newArrowId
      ).lineCordinates.x2 = $event.offsetX;
      this.nodes.find(
        (m: any) => m.nodeId == this.newArrowId
      ).lineCordinates.y2 = $event.offsetY;
    }

    if (
      this.clickedParent.nodeId == undefined &&
      this.clickedChild.nodeId != undefined
    ) {
      this.nodes.find(
        (m: any) => m.nodeId == this.newArrowId
      ).lineCordinates.x1 = $event.offsetX;
      this.nodes.find(
        (m: any) => m.nodeId == this.newArrowId
      ).lineCordinates.y1 = $event.offsetY;
    }

    if (this.firstClick && !this.lastClick) {
      this.nodes.find(
        (m: any) => m.nodeId == this.newLineId
      ).lineCordinates.x2 = $event.offsetX;
      this.nodes.find(
        (m: any) => m.nodeId == this.newLineId
      ).lineCordinates.y2 = $event.offsetY;
    }
  }

  poolLinemouseDown($event: any, node: any) {
    this.currentDraggableLine = node;
    this.currentDraggableLineObj = {};
    this.currentDraggableLineObj.oldX1diff = $event.offsetX - node.lineCordinates.x1;
    this.currentDraggableLineObj.oldY1diff = $event.offsetY - node.lineCordinates.y1;
    this.currentDraggableLineObj.oldX2diff = $event.offsetX - node.lineCordinates.x2;
    this.currentDraggableLineObj.oldY2diff = $event.offsetY - node.lineCordinates.y2;
  }

  poolLinemouseUp() {
    this.currentDraggableLine = {};
    this.currentDraggableLineObj = {};
  }

  svgMouseUp() {
    this.currentDraggableArrowPoint = {};
    this.poolLinemouseUp();
  }

  arrowCurveDown($event, arrow) {
    this.currentDraggableArrowPoint = arrow;
  }

  arrowCurveUp($event, arrow) {
    this.currentDraggableArrowPoint = {};
    this.nodes.map(m => m.pickerStyle = 'fill:#0bc928;stroke-width: 1;display:none;');
    this.nodes.forEach(m => {
      m.childs.forEach(n => n.pickerStyle = 'fill:#0bc928;stroke-width: 1;display:none;');
    });
    this.arrows = [];
    this.nodes.forEach((node: any) => {
      node.childs.forEach((child: any) => {
        this.arrows.push(child);
      });
    });
  }

  lineDrawLogic($event) {
    if (!this.firstClick) {
      let newNode = JSON.parse(
        '{"nodeId":44,"nodeType":"poolline","nodeY":10,"nodeX":10,"height":400,"width":800,"name":"poolLine","className":"class44","bg":"","patternId":"","patternImage":"","lineCordinates":{"x1":10,"y1":10,"x2":50,"y2":10},"touchPoints":{"topCenter":{"x":0,"y":0},"rightCenter":{"x":0,"y":0},"bottomCenter":{"x":0,"y":0},"leftCenter":{"x":0,"y":0},"mid":{"x":0,"y":0}},"style":"fill:#5DADE2;stroke-width: 3; stroke: #5DADE2;","parents":[],"childs":[], "pickerStyle": "fill:#0bc928;stroke-width: 1;"}'
      );
      newNode.lineCordinates.x1 = $event.offsetX;
      newNode.lineCordinates.y1 = $event.offsetY;
      newNode.lineCordinates.x2 = $event.offsetX;
      newNode.lineCordinates.y2 = $event.offsetY;
      if (newNode) {
        const newNodeId =
          Math.max(...this.nodes.map((m: any) => m.nodeId)) + 1;
        this.newLineId = newNodeId;
        newNode.nodeId = newNodeId;
        newNode.className = 'class' + newNodeId;
        newNode.nodeX = $event.offsetX;
        newNode.nodeY = $event.offsetY;
        this.nodes.push(newNode);
        this.initMethod();
      }
      this.firstClick = true;
    } else if (this.firstClick && !this.lastClick) {
      this.nodes.find(
        (m: any) => m.nodeId == this.newLineId
      ).lineCordinates.x2 = $event.offsetX;
      this.nodes.find(
        (m: any) => m.nodeId == this.newLineId
      ).lineCordinates.y2 = $event.offsetY;
      this.firstClick = false;
      this.isSymbolSelected = false;
      this.updateStrokes(false);
    }
  }

  arrowMouseDown($event: any, data: any, side: any) {
    this.isArrowMouseDownClicked = true;
    this.arraowSide = side;
    const currentnode = this.nodes.find((m: any) => m.nodeId == data.parentId);
    if (currentnode) {
      this.isSymbolSelected = true;
      this.selectedSymbolType = 'arrow';
      const connectedChild = currentnode.childs.find((m: any) => m.id == data.id);
      currentnode.childs = currentnode.childs.filter((m: any) => m.id != data.id);
      this.createLinetoArrow($event, currentnode, data.id, connectedChild);
    }
  }

  createLinetoArrow($event: any, currentnode: any, childNodeId: any, connectedChild: any) {
    if (this.arraowSide == 'E') {
      this.clickedParent = currentnode;
    } else {
      currentnode = this.nodes.find((m: any) => m.nodeId == childNodeId);
      this.clickedChild = currentnode;
    }
    let newNode = JSON.parse(
      '{"nodeId":44,"nodeType":"linetoarrow","nodeY":10,"nodeX":10,"height":400,"width":800,"name":"poolLine","className":"class44","bg":"","patternId":"","patternImage":"","lineCordinates":{"x1":10,"y1":10,"x2":50,"y2":10},"touchPoints":{"topCenter":{"x":0,"y":0},"rightCenter":{"x":0,"y":0},"bottomCenter":{"x":0,"y":0},"leftCenter":{"x":0,"y":0},"mid":{"x":0,"y":0}},"style":"' + connectedChild.lineStyle + '","parents":[],"childs":[], "pickerStyle": "fill:#0bc928;stroke-width: 3;"}'
    );
    newNode.lineCordinates.x1 = this.arraowSide == 'E' ? currentnode.touchPoints.mid.x : $event.offsetX;
    newNode.lineCordinates.y1 = this.arraowSide == 'E' ? currentnode.touchPoints.mid.y : $event.offsetY;
    newNode.lineCordinates.x2 = this.arraowSide == 'E' ? $event.offsetX : connectedChild.x2;
    newNode.lineCordinates.y2 = this.arraowSide == 'E' ? $event.offsetY : connectedChild.y2;
    if (newNode) {
      const newNodeId =
        Math.max(...this.nodes.map((m: any) => m.nodeId)) + 1;
      this.newArrowId = newNodeId;
      newNode.nodeId = newNodeId;
      newNode.className = 'class' + newNodeId;
      newNode.nodeX = $event.offsetX;
      newNode.nodeY = $event.offsetY;
      this.nodes.push(newNode);
      this.initMethod();
    }
  }

  completeArrowCreation(currentnode: any) {
    this.clickedChild = currentnode;
    const newArrowSymbolObj = this.nodes.find(
      (m: any) => m.nodeId == this.newArrowId
    );
    newArrowSymbolObj.lineCordinates.x2 = currentnode.touchPoints.mid.x;
    newArrowSymbolObj.lineCordinates.y2 = currentnode.touchPoints.mid.y;
    const childId = this.clickedChild.nodeId;
    const parentId = this.clickedParent.nodeId;
    this.clickedParent.childs.push({
      id: childId,
      lineStyle: newArrowSymbolObj.style,
      x1: 0,
      y1: 0,
      x2: 0,
      y2: 0,
      className: 'class' + childId + 'HS Line',
    });
    this.clickedChild.parents.push({ id: parentId });
    this.nodes = this.nodes.filter(
      (m: any) => m.nodeId != this.newArrowId
    );
    this.clickedParent = {};
    this.clickedChild = {};
    this.newArrowId = 0;
    this.updateStrokes(false);
    this.initMethod();
    this.isSymbolSelected = false;
  }

  newArrowMouseDown(
    $event: any,
    data: any,
    side: any
  ): void {
    if (this.clickedParent.nodeId == undefined && this.clickedChild.nodeId == undefined) {
      this.arraowSide = side;
      this.newArrowId = data.nodeId;
      this.newArrowMouseDownStatus = true;
    }
  }

  newArrowMouseUp(
    $event: any,
    data: any
  ): void {
    if (this.clickedParent.nodeId == undefined && this.clickedChild.nodeId == undefined) {
      this.newArrowMouseDownStatus = false;
    }
  }

  mouseDown(
    $event: any,
    data: any,
    className: any,
    isPoolDrag: boolean = false,
    isLineStart: boolean = false
  ): void {
    const currentnode = this.nodes.find((m: any) => m.nodeId == data);
    if (currentnode.nodeType == 'poolline') {
      this.currentDraggablePoolLinePoint = currentnode;
      this.isCurrentPoolLineStart = isLineStart;
    } else if (currentnode.nodeType == 'pool' && isPoolDrag) {
      this.currentDraggablePoolNode = currentnode;
    } else {
      this.currentDraggableNode = currentnode;
    }
    if (this.isSymbolSelected) {
      if (this.selectedSymbolType == 'arrow') {
        if (this.arraowSide == 'E' || this.arraowSide == '') {
          if (this.clickedParent.nodeId == undefined) {
            this.clickedChild = currentnode;
            const newArrowObj = this.nodes.find(
              (m: any) => m.nodeId == this.newArrowId
            );
            if (newArrowObj) {
              newArrowObj.lineCordinates.x2 = currentnode.touchPoints.mid.x;
              newArrowObj.lineCordinates.y2 = currentnode.touchPoints.mid.y;
              const childId = this.clickedChild.nodeId;
              const parentId = this.clickedParent.nodeId;
              this.clickedParent.childs.push({
                id: childId,
                lineStyle: 'fill:transparent;stroke: #5DADE2; stroke-width: 1;',
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 0,
                className: 'class' + childId + 'HS Line',
              });
              this.clickedChild.parents.push({ id: parentId });
              this.nodes = this.nodes.filter(
                (m: any) => m.nodeId != this.newArrowId
              );
              this.clickedParent = {};
              this.clickedChild = {};
              this.newArrowId = 0;
              this.updateStrokes(false);
              this.initMethod();
              this.isSymbolSelected = false;
            }
          } else if (//arrow head close
            this.clickedParent.nodeId != undefined &&
            this.clickedChild.nodeId == undefined
          ) {
            this.completeArrowCreation(currentnode);
          }
        } else {
          const newArrowObj = this.nodes.find(
            (m: any) => m.nodeId == this.newArrowId
          );
          currentnode.childs.push({
            id: this.clickedChild.nodeId,
            lineStyle: newArrowObj.style,
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            className: 'class' + this.clickedChild.nodeId + 'HS Line',
          });
          this.clickedChild.parents.push({ id: currentnode.nodeId });
          this.nodes = this.nodes.filter(
            (m: any) => m.nodeId != this.newArrowId
          );
          this.clickedParent = {};
          this.clickedChild = {};
          this.newArrowId = 0;
          this.updateStrokes(false);
          this.initMethod();
          this.isSymbolSelected = false;
        }
      }
    }
    this.oldClientX = $event.clientX;
    this.oldClientY = $event.clientY;
  }

  mouseUp(
    $event: any,
    data: any,
    className: any,
    isPoolDrag: boolean = false,
    isLineStart: boolean = false
  ): void {
    if (this.isArrowMouseDownClicked) {
      this.isArrowMouseDownClicked = false;
      this.mouseDown($event, data, className, isPoolDrag, isLineStart);
    }
    const currentnode = this.nodes.find((m: any) => m.nodeId == data);
    if (this.newArrowMouseDownStatus) {
      const currentArrow = this.nodes.find((m: any) => m.nodeId == this.newArrowId);
      if (this.arraowSide == 'S') {
        currentArrow.parents.push({
          id: data
        });
      } else if (this.arraowSide == 'E') {
        currentArrow.childs.push({
          id: data
        });
      }
      if (currentArrow.childs.length > 0 && currentArrow.parents.length > 0) {
        this.newArrowMouseDownStatus = false;
        this.BindNewArrow(currentArrow);
      }
      this.newArrowMouseDownStatus = false;
    } else {
      if (currentnode) {
        const nodeType = currentnode.nodeType;
        if (isPoolDrag) {
          if (nodeType == 'poolline') {
            if (isLineStart) {
              currentnode.lineCordinates.x1 += $event.clientX - this.oldClientX;
              currentnode.lineCordinates.y1 += $event.clientY - this.oldClientY;
            } else {
              currentnode.lineCordinates.x2 += $event.clientX - this.oldClientX;
              currentnode.lineCordinates.y2 += $event.clientY - this.oldClientY;
            }
          } else {
            currentnode.width += $event.clientX - this.oldClientX;
            currentnode.height += $event.clientY - this.oldClientY;
          }
        }

        this.currentDraggablePoolNode = {};
        this.currentDraggableNode = {};
        this.currentDraggablePoolLinePoint = {};
        this.clickedParent = {};
        this.clickedChild = {};
        this.getClosestPoints();
        this.setParentChildNodes(currentnode);
        this.getLines();
      }
    }
  }

  BindNewArrow(currentArrow) {
    const childId = currentArrow.childs[0].id;
    const parentId = currentArrow.parents[0].id;
    const parentNode = this.nodes.find((m: any) => m.nodeId == parentId);
    const childNode = this.nodes.find((m: any) => m.nodeId == childId);
    parentNode.childs.push({
      id: childId,
      lineStyle: 'fill:transparent;stroke: #5DADE2; stroke-width: 3;',
      x1: 0,
      y1: 0,
      x2: 0,
      y2: 0,
      className: 'class' + childId + 'HS Line',
    });
    childNode.parents.push({ id: parentId });
    this.nodes = this.nodes.filter((m: any) => m.nodeId != currentArrow.nodeId);
    this.initMethod();
  }

  getDistance(x1: any, y1: any, x2: any, y2: any) {
    let y = x2 - x1;
    let x = y2 - y1;
    return Math.sqrt(x * x + y * y);
  }

  getMinimumDistanceObjectByChildId(
    res: any,
    currentnodeId: any,
    childId: any
  ) {
    res = res.filter(
      (m: any) => m.childnodeId == childId && m.currentnodeId == currentnodeId
    );
    const minDistance = this.sort_by_key(res, 'distance');
    return minDistance[0];
  }

  sort_by_key(array: any, key: any) {
    return array.sort(function (a: any, b: any) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }

  getValueFromStyle(style: any, property: any) {
    if (style) {
      const styleArray = style.split(';');
      const arrObj = styleArray.find(m => m.indexOf(property) > -1);
      return arrObj ? arrObj.split(':')[1].trim() : '';
    }
  }

  reloadWF() {
    if (this.svgDataList) {
      this.nodes = this.svgDataList.find(m => m.name == this.currentWF).value;
      this.initMethod();
    }
  }

  symbolClick(nodeObj: any) {
    this.isNameDisabled = false;
    this.isDisabled = false;
    this.isColorDisabled = false;
    this.iselectedSymbolArrow = false;
    if (nodeObj.nodeId) {
      this.clickNonArrowSymbol(nodeObj);
    } else {
      this.clickArrowSymbol(nodeObj);
    }
    this.pickerClick(nodeObj);
  }

  clickArrowSymbol(nodeObj: any) {
    this.isColorDisabled = true;
    this.iselectedSymbolArrow = true;
    this.isNameDisabled = true;
    const parentObj = this.nodes.find(m => m.nodeId == nodeObj.parentId);
    const childObj = parentObj.childs.find(m => m.id == nodeObj.id);
    this.selectedSymbolColor = this.getValueFromStyle(childObj.lineStyle, 'fill:');
    this.selectedSymbolStrokeColor = this.getValueFromStyle(childObj.lineStyle, 'stroke:');
    this.selectedStrokeWidth = this.getValueFromStyle(childObj.lineStyle, 'stroke-width:');
    this.selectedStrokeDash = this.getValueFromStyle(childObj.lineStyle, 'stroke-dasharray:');
    this.selectedSymbol = childObj;
    this.selectedSymbol.name = 'Arrow';
  }

  clickNonArrowSymbol(nodeObj: any) {
    this.selectedSymbol = JSON.parse(JSON.stringify(this.nodes.find(m => m.nodeId == nodeObj.nodeId)));
    this.selectedSymbolColor = this.getValueFromStyle(this.selectedSymbol.style, 'fill:');
    this.selectedSymbolStrokeColor = this.getValueFromStyle(this.selectedSymbol.style, 'stroke:');
    this.selectedStrokeWidth = this.getValueFromStyle(this.selectedSymbol.style, 'stroke-width:');
    this.selectedStrokeDash = this.getValueFromStyle(this.selectedSymbol.style, 'stroke-dasharray:');
    this.selectedSymbolFont = this.getValueFromStyle(this.selectedSymbol.fontStyle, 'font-family:');
    this.selectedSymbolFontSize = this.getValueFromStyle(this.selectedSymbol.fontStyle, 'font-size:');
    this.selectedtextColor = this.getValueFromStyle(this.selectedSymbol.fontStyle, 'fill:');
    this.isDisabled = false;
    const nodetype = this.selectedSymbol.nodeType;
    if (nodetype == 'poolline') {
      this.isNameDisabled = true;
      this.isColorDisabled = true;
      this.selectedStrokeWidth = this.getValueFromStyle(this.selectedSymbol.style, 'stroke-width:');
    }
  }

  UpdateRecord() {
    if (this.iselectedSymbolArrow) {
      this.updateArrowSymbol();
    } else {
      this.updateNonArrowSymbol();
    }
  }

  updateNonArrowSymbol() {
    const obj = this.nodes.find(m => m.nodeId == this.selectedSymbol.nodeId);
    obj.name = this.selectedSymbol.name;
    obj.style = this.getStyleFromProperty(obj.style, 'fill:', this.selectedSymbolColor);
    obj.style = this.getStyleFromProperty(obj.style, 'stroke:', this.selectedSymbolStrokeColor);
    obj.style = this.getStyleFromProperty(obj.style, 'stroke-width:', this.selectedStrokeWidth);
    obj.fontStyle = this.getStyleFromProperty(obj.fontStyle, 'font-family:', this.selectedSymbolFont);
    obj.fontStyle = this.getStyleFromProperty(obj.fontStyle, 'font-size:', this.selectedSymbolFontSize);
    obj.fontStyle = this.getStyleFromProperty(obj.fontStyle, 'fill:', this.selectedtextColor);
    if (this.selectedStrokeDash != '') {
      obj.style = this.getStyleFromProperty(obj.style, 'stroke-dasharray:', this.selectedStrokeDash);
    }
  }

  updateArrowSymbol() {
    this.selectedSymbol.lineStyle = this.getStyleFromProperty(this.selectedSymbol.lineStyle, 'stroke:', this.selectedSymbolStrokeColor);
    this.selectedSymbol.lineStyle = this.getStyleFromProperty(this.selectedSymbol.lineStyle, 'stroke-width:', this.selectedStrokeWidth);
    if (this.selectedStrokeDash != '') {
      this.selectedSymbol.lineStyle = this.getStyleFromProperty(this.selectedSymbol.lineStyle, 'stroke-dasharray:', this.selectedStrokeDash);
    }
  }

  DeleteRecord() {
    const id = this.selectedSymbol.nodeId;
    const parents = this.selectedSymbol.parents;
    const childs = this.selectedSymbol.childs;
    parents.map(parent => {
      const parentNode = this.nodes.find(m => m.nodeId == parent.id);
      parentNode.childs = parentNode.childs.filter(m => m.id != id);
    });
    childs.map(child => {
      const childNode = this.nodes.find(m => m.nodeId == child.id);
      childNode.parents = childNode.parents.filter(m => m.id != id);
    });
    this.nodes = this.nodes.filter(m => m.nodeId != id);
    this.close();
    this.initMethod();
  }

  saveSVG() {
    const nameSVG = (this.svgName.length == 0 ? 'SVG_' + formatDate(new Date(), 'yyyyMMddhhmmss', 'en-US') : this.svgName)
    let svgDataLists = JSON.parse(sessionStorage.getItem("svgDataList"));
    if (svgDataLists) {
      svgDataLists.push({ name: nameSVG, value: this.nodes });
    } else {
      svgDataLists = [{ name: nameSVG, value: this.nodes }];
    }
    sessionStorage.setItem('svgDataList', JSON.stringify(svgDataLists));
    this.svgDataList = JSON.parse(sessionStorage.getItem("svgDataList"));
  }

  getStyleFromProperty(style: any, property: any, propertyValue: any) {
    if (style) {
      let styleObj = style;
      const fillIndex = styleObj.indexOf(property);
      if (fillIndex > -1) {
        const styleArray = styleObj.split(';').filter(m => m.trim() != '');
        styleObj = '';
        styleArray.filter(m => m.indexOf(property) == -1).forEach(m => {
          styleObj += m + ';';
        });
      }
      style = property == 'fill:' ? (property + propertyValue + ";" + styleObj) : (styleObj + ";" + property + propertyValue + ";");
    }
    return style;
  }

  close() {
    this.dialog.closeAll();
  }

  updateStrokes(isClicked: boolean) {
    if (
      this.selectedSymbolType == 'arrow' ||
      this.selectedSymbolType == 'poolline'
    ) {
      const nameClass = this.selectedSymbolType + 'master';
      Array.from(document.getElementsByClassName(nameClass)).forEach(
        (element: any) => {
          element.style.stroke = isClicked ? '#280DEF' : '#48C9B0';
        }
      );
    }
  }

  createSelectedSymbol($event: any) {
    if (this.isSymbolSelected) {
      this.updateStrokes(false);
      let newNode: any;
      let newNodeId: any = 0;
      switch (this.selectedSymbolType) {
        case 'start':
          newNode = JSON.parse(
            '{"nodeId":1,"nodeType":"startend","nodeY":100,"nodeX":50,"height":0,"width":0,"name":"Start","className":"StartClass","bg":"","patternId":"","patternImage":"","lineCordinates":{"x1":0,"y1":0,"x2":0,"y2":0},"touchPoints":{"topCenter":{"x":0,"y":0},"rightCenter":{"x":0,"y":0},"bottomCenter":{"x":0,"y":0},"leftCenter":{"x":0,"y":0},"mid":{"x":0,"y":0}},"parents":[],"style":"fill: #88EAEA; stroke-width: 1; stroke: #d7dbdd","childs":[]}'
          );
          break;
        case 'arrow':
          newNode = JSON.parse(
            '{"nodeId":44,"nodeType":"linetoarrow","nodeY":10,"nodeX":10,"height":400,"width":800,"name":"poolLine","className":"class44","bg":"","patternId":"","patternImage":"","lineCordinates":{"x1":10,"y1":10,"x2":50,"y2":10},"touchPoints":{"topCenter":{"x":0,"y":0},"rightCenter":{"x":0,"y":0},"bottomCenter":{"x":0,"y":0},"leftCenter":{"x":0,"y":0},"mid":{"x":0,"y":0}},"style":"fill:#5DADE2;stroke-width: 3; stroke: #5DADE2;","parents":[],"childs":[], "pickerStyle": "fill:#0bc928;stroke-width: 1;"}'
          );
          newNode.lineCordinates.x1 = $event.offsetX;
          newNode.lineCordinates.y1 = $event.offsetY;
          newNode.lineCordinates.x2 = $event.offsetX + 100;
          newNode.lineCordinates.y2 = $event.offsetY;
          break;
        case 'poolline':
          this.lineDrawLogic($event);
          break;
        case 'startcircle':
          newNode = JSON.parse(
            '{"nodeId":2,"nodeType":"startcircle","nodeY":200,"nodeX":50,"height":0,"width":0,"name":"Circle","className":"class2","bg":"","patternId":"","patternImage":"","lineCordinates":{"x1":0,"y1":0,"x2":0,"y2":0},"touchPoints":{"topCenter":{"x":0,"y":0},"rightCenter":{"x":0,"y":0},"bottomCenter":{"x":0,"y":0},"leftCenter":{"x":0,"y":0},"mid":{"x":0,"y":0}},"style":"fill: #8CEE9F; stroke-width: 1; stroke: #d7dbdd;","parents":[],"childs":[]}'
          );
          break;
        case 'intermidiateprocess':
          newNode = JSON.parse(
            '{"nodeId":2,"nodeType":"intermediatecircle","nodeY":200,"nodeX":50,"height":0,"width":0,"name":"IProcess","className":"class2","bg":"","patternId":"","patternImage":"","lineCordinates":{"x1":0,"y1":0,"x2":0,"y2":0},"touchPoints":{"topCenter":{"x":0,"y":0},"rightCenter":{"x":0,"y":0},"bottomCenter":{"x":0,"y":0},"leftCenter":{"x":0,"y":0},"mid":{"x":0,"y":0}},"style":"fill: #8CEE9F; stroke-width: 1; stroke: #d7dbdd;","parents":[],"childs":[]}'
          );
          break;
        case 'process':
          newNode = JSON.parse(
            '{"nodeId":2,"nodeType":"process","nodeY":200,"nodeX":50,"height":0,"width":0,"name":"Process","className":"class2","bg":"","patternId":"","patternImage":"","lineCordinates":{"x1":0,"y1":0,"x2":0,"y2":0},"touchPoints":{"topCenter":{"x":0,"y":0},"rightCenter":{"x":0,"y":0},"bottomCenter":{"x":0,"y":0},"leftCenter":{"x":0,"y":0},"mid":{"x":0,"y":0}},"style":"fill: #8CEE9F; stroke-width: 1; stroke: #d7dbdd;","parents":[],"childs":[]}'
          );
          break;
        case 'rectsubprocess':
          newNode = JSON.parse(
            '{"nodeId":2,"nodeType":"rectsubprocess","nodeY":200,"nodeX":50,"height":0,"width":0,"name":"Sub Process","className":"class2","bg":"","patternId":"","patternImage":"","lineCordinates":{"x1":0,"y1":0,"x2":0,"y2":0},"touchPoints":{"topCenter":{"x":0,"y":0},"rightCenter":{"x":0,"y":0},"bottomCenter":{"x":0,"y":0},"leftCenter":{"x":0,"y":0},"mid":{"x":0,"y":0}},"style":"fill: #8CEE9F; stroke-width: 3; stroke: #707B7C ;stroke-dasharray: 5,5;","parents":[],"childs":[]}'
          );
          break;
        case 'rectcall':
          newNode = JSON.parse(
            '{"nodeId":2,"nodeType":"rectcall","nodeY":200,"nodeX":50,"height":0,"width":0,"name":"Call","className":"class2","bg":"","patternId":"","patternImage":"","lineCordinates":{"x1":0,"y1":0,"x2":0,"y2":0},"touchPoints":{"topCenter":{"x":0,"y":0},"rightCenter":{"x":0,"y":0},"bottomCenter":{"x":0,"y":0},"leftCenter":{"x":0,"y":0},"mid":{"x":0,"y":0}},"style":"fill: #8CEE9F; stroke-width: 5; stroke: #707B7C ;","parents":[],"childs":[]}'
          );
          break;
        case 'recttransaction':
          newNode = JSON.parse(
            '{"nodeId":2,"nodeType":"recttransaction","nodeY":200,"nodeX":50,"height":0,"width":0,"name":"test","className":"class2","bg":"","patternId":"","patternImage":"","lineCordinates":{"x1":0,"y1":0,"x2":0,"y2":0},"touchPoints":{"topCenter":{"x":0,"y":0},"rightCenter":{"x":0,"y":0},"bottomCenter":{"x":0,"y":0},"leftCenter":{"x":0,"y":0},"mid":{"x":0,"y":0}},"style":"fill: #8CEE9F; stroke-width: 2; stroke: #707B7C ;","parents":[],"childs":[]}'
          );
          break;
        case 'decision':
          newNode = JSON.parse(
            '{"nodeId":2,"nodeType":"decision","nodeY":200,"nodeX":50,"height":0,"width":0,"decision":"Call","className":"class2","bg":"","patternId":"","patternImage":"","lineCordinates":{"x1":0,"y1":0,"x2":0,"y2":0},"touchPoints":{"topCenter":{"x":0,"y":0},"rightCenter":{"x":0,"y":0},"bottomCenter":{"x":0,"y":0},"leftCenter":{"x":0,"y":0},"mid":{"x":0,"y":0}},"style":"fill: #8CEE9F; stroke-width: 2; stroke: #707B7C ;","parents":[],"childs":[]}'
          );
          break;
        case 'freetext':
          newNode = JSON.parse(
            '{"nodeId":2,"nodeType":"freetext","nodeY":200,"nodeX":50,"height":0,"width":0,"name":"freetext","className":"class2","bg":"","patternId":"","patternImage":"","lineCordinates":{"x1":0,"y1":0,"x2":0,"y2":0},"touchPoints":{"topCenter":{"x":0,"y":0},"rightCenter":{"x":0,"y":0},"bottomCenter":{"x":0,"y":0},"leftCenter":{"x":0,"y":0},"mid":{"x":0,"y":0}},"style":"fill: #8CEE9F; stroke-width: 2; stroke: #707B7C ;","parents":[],"childs":[]}'
          );
          break;
        case 'pool':
          newNode = JSON.parse(
            '{"nodeId":2,"nodeType":"pool","nodeY":200,"nodeX":50,"height":50,"width":50,"name":"freetext","pool":"class2","bg":"","patternId":"","patternImage":"","lineCordinates":{"x1":0,"y1":0,"x2":0,"y2":0},"touchPoints":{"topCenter":{"x":0,"y":0},"rightCenter":{"x":0,"y":0},"bottomCenter":{"x":0,"y":0},"leftCenter":{"x":0,"y":0},"mid":{"x":0,"y":0}},"style":"fill: #8CEE9F; stroke-width: 2; stroke: #707B7C ;","parents":[],"childs":[]}'
          );
          break;
        case 'event':
          newNode = JSON.parse(
            '{"nodeId":2,"nodeType":"circleevent","nodeY":200,"nodeX":50,"height":50,"width":50,"name":"freetext","pool":"class2","bg":"' +
            this.selectImgObj.fillImg +
            '","patternId":"' +
            this.selectImgObj.id +
            '","patternImage":"' +
            this.selectImgObj.imgPath +
            '","lineCordinates":{"x1":0,"y1":0,"x2":0,"y2":0},"touchPoints":{"topCenter":{"x":0,"y":0},"rightCenter":{"x":0,"y":0},"bottomCenter":{"x":0,"y":0},"leftCenter":{"x":0,"y":0},"mid":{"x":0,"y":0}},"style":"stroke-width: 2; stroke: #707B7C ;","parents":[],"childs":[]}'
          );
          break;
      }
      if (newNode && this.selectedSymbolType != 'poolline') {
        newNodeId = this.nodes.length == 0 ? 1 : Math.max(...this.nodes.map((m: any) => m.nodeId)) + 1;
        newNode.nodeId = newNodeId;
        this.newArrowId = this.selectedSymbolType == 'arrow' ? newNodeId : 0;
        newNode.className = 'class' + newNodeId;
        newNode.nodeX = $event.offsetX;
        newNode.nodeY = $event.offsetY;
        this.nodes.push(newNode);
        this.initMethod();
        this.isSymbolSelected = false;
      }
    }
  }

  deleteArrow(arrow: any) {
    const nodeId = arrow.parentId;
    const childId = arrow.id;
    this.nodes.find((m: any) => m.nodeId == nodeId).childs = this.nodes
      .find((m: any) => m.nodeId == nodeId)
      .childs.filter((c: any) => c.id != childId);
    this.initMethod();
  }

  deletePoolLine(poolline: any) {
    this.nodes = this.nodes.filter((m: any) => m.nodeId != poolline.nodeId);
    this.initMethod();
  }

  getClosestPoints() {
    this.nodes.forEach((node: any) => {
      const x = node.nodeX;
      const y = node.nodeY;
      const nodeType = node.nodeType;

      switch (nodeType) {
        case 'pool':
          const height = node.height;
          const width = node.width;
          node.touchPoints.mid.x = x + width / 2;
          node.touchPoints.mid.y = y + height / 2;

          node.touchPoints.topCenter.x = node.touchPoints.mid.x;
          node.touchPoints.topCenter.y = node.touchPoints.mid.y - height / 2;

          node.touchPoints.rightCenter.x = node.touchPoints.mid.x + width / 2;
          node.touchPoints.rightCenter.y = node.touchPoints.mid.y;

          node.touchPoints.bottomCenter.x = node.touchPoints.mid.x;
          node.touchPoints.bottomCenter.y = node.touchPoints.mid.y + height / 2;

          node.touchPoints.leftCenter.x = node.touchPoints.mid.x - width / 2;
          node.touchPoints.leftCenter.y = node.touchPoints.mid.y;

          break;
        case 'circleevent':
          node.touchPoints.mid.x = x + this.circleEventWidth / 2;
          node.touchPoints.mid.y = y + this.circleEventWidth / 2;

          node.touchPoints.topCenter.x = node.touchPoints.mid.x;
          node.touchPoints.topCenter.y =
            node.touchPoints.mid.y - this.circleEventWidth / 2;

          node.touchPoints.rightCenter.x =
            node.touchPoints.mid.x + this.circleEventWidth / 2;
          node.touchPoints.rightCenter.y = node.touchPoints.mid.y;

          node.touchPoints.bottomCenter.x = node.touchPoints.mid.x;
          node.touchPoints.bottomCenter.y =
            node.touchPoints.mid.y + this.circleEventWidth / 2;

          node.touchPoints.leftCenter.x =
            node.touchPoints.mid.x - this.circleEventWidth / 2;
          node.touchPoints.leftCenter.y = node.touchPoints.mid.y;

          break;
        case 'startcircle':
        case 'intermediatecircle':
        case 'endcircle':
        case 'circlemail':
          node.touchPoints.mid.x = x + this.circleWidth / 2;
          node.touchPoints.mid.y = y + this.circleWidth / 2;

          node.touchPoints.topCenter.x = node.touchPoints.mid.x;
          node.touchPoints.topCenter.y =
            node.touchPoints.mid.y - this.circleWidth / 2;

          node.touchPoints.rightCenter.x =
            node.touchPoints.mid.x + this.circleWidth / 2;
          node.touchPoints.rightCenter.y = node.touchPoints.mid.y;

          node.touchPoints.bottomCenter.x = node.touchPoints.mid.x;
          node.touchPoints.bottomCenter.y =
            node.touchPoints.mid.y + this.circleWidth / 2;

          node.touchPoints.leftCenter.x =
            node.touchPoints.mid.x - this.circleWidth / 2;
          node.touchPoints.leftCenter.y = node.touchPoints.mid.y;

          break;
        case 'decision':
          const decisionTC = this.rotatePoint(
            x,
            y,
            x + this.decisionWidth / 2,
            y + this.decisionWidth / 2,
            this.decisionRotate
          );
          node.touchPoints.topCenter.x = decisionTC.newX;
          node.touchPoints.topCenter.y = decisionTC.newY;

          const decisionRC = this.rotatePoint(
            x + this.decisionWidth,
            y,
            x + this.decisionWidth / 2,
            y + this.decisionWidth / 2,
            this.decisionRotate
          );
          node.touchPoints.rightCenter.x = decisionRC.newX;
          node.touchPoints.rightCenter.y = decisionRC.newY;

          const decisionBC = this.rotatePoint(
            x + this.decisionWidth,
            y + this.decisionWidth,
            x + this.decisionWidth / 2,
            y + this.decisionWidth / 2,
            this.decisionRotate
          );
          node.touchPoints.bottomCenter.x = decisionBC.newX;
          node.touchPoints.bottomCenter.y = decisionBC.newY;

          const decisionLC = this.rotatePoint(
            x,
            y + this.decisionWidth,
            x + this.decisionWidth / 2,
            y + this.decisionWidth / 2,
            this.decisionRotate
          );
          node.touchPoints.leftCenter.x = decisionLC.newX;
          node.touchPoints.leftCenter.y = decisionLC.newY;

          const decisionMID = this.rotatePoint(
            x + this.decisionWidth,
            y + this.decisionWidth,
            x + this.decisionWidth / 2,
            y + this.decisionWidth / 2,
            this.decisionRotate
          );
          node.touchPoints.mid.x = decisionMID.newX;
          node.touchPoints.mid.y = decisionMID.newY;

          break;
        default:
          node.touchPoints.topCenter.x = x + this.nodeWidth / 2;
          node.touchPoints.topCenter.y = y;

          node.touchPoints.rightCenter.x = x + this.nodeWidth;
          node.touchPoints.rightCenter.y = y + this.nodeHeight / 2;

          node.touchPoints.bottomCenter.x = x + this.nodeWidth / 2;
          node.touchPoints.bottomCenter.y = y + this.nodeHeight;

          node.touchPoints.leftCenter.x = x;
          node.touchPoints.leftCenter.y = y + this.nodeHeight / 2;

          node.touchPoints.mid.x = x + this.nodeWidth / 2;
          node.touchPoints.mid.y = y + this.nodeHeight / 2;
      }
    });
  }

  getNewChildPoints(currentnode: any, childIds: any, parentIds: any) {
    let res: any = [];
    let touchPoint = currentnode.touchPoints;
    if (childIds.length > 0) {
      childIds.forEach((childId: any) => {
        let childnode = this.nodes.find((m: any) => m.nodeId == childId);
        if (childnode) {
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: childId,
            x1: touchPoint.topCenter.x,
            y1: touchPoint.topCenter.y,
            x2: childnode.touchPoints.topCenter.x,
            y2: childnode.touchPoints.topCenter.y,
            distance: this.getDistance(
              touchPoint.topCenter.x,
              touchPoint.topCenter.y,
              childnode.touchPoints.topCenter.x,
              childnode.touchPoints.topCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: childId,
            x1: touchPoint.topCenter.x,
            y1: touchPoint.topCenter.y,
            x2: childnode.touchPoints.rightCenter.x,
            y2: childnode.touchPoints.rightCenter.y,
            distance: this.getDistance(
              touchPoint.topCenter.x,
              touchPoint.topCenter.y,
              childnode.touchPoints.rightCenter.x,
              childnode.touchPoints.rightCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: childId,
            x1: touchPoint.topCenter.x,
            y1: touchPoint.topCenter.y,
            x2: childnode.touchPoints.bottomCenter.x,
            y2: childnode.touchPoints.bottomCenter.y,
            distance: this.getDistance(
              touchPoint.topCenter.x,
              touchPoint.topCenter.y,
              childnode.touchPoints.bottomCenter.x,
              childnode.touchPoints.bottomCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: childId,
            x1: touchPoint.topCenter.x,
            y1: touchPoint.topCenter.y,
            x2: childnode.touchPoints.leftCenter.x,
            y2: childnode.touchPoints.leftCenter.y,
            distance: this.getDistance(
              touchPoint.topCenter.x,
              touchPoint.topCenter.y,
              childnode.touchPoints.leftCenter.x,
              childnode.touchPoints.leftCenter.y
            ),
          });

          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: childId,
            x1: touchPoint.rightCenter.x,
            y1: touchPoint.rightCenter.y,
            x2: childnode.touchPoints.topCenter.x,
            y2: childnode.touchPoints.topCenter.y,
            distance: this.getDistance(
              touchPoint.rightCenter.x,
              touchPoint.rightCenter.y,
              childnode.touchPoints.topCenter.x,
              childnode.touchPoints.topCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: childId,
            x1: touchPoint.rightCenter.x,
            y1: touchPoint.rightCenter.y,
            x2: childnode.touchPoints.rightCenter.x,
            y2: childnode.touchPoints.rightCenter.y,
            distance: this.getDistance(
              touchPoint.rightCenter.x,
              touchPoint.rightCenter.y,
              childnode.touchPoints.rightCenter.x,
              childnode.touchPoints.rightCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: childId,
            x1: touchPoint.rightCenter.x,
            y1: touchPoint.rightCenter.y,
            x2: childnode.touchPoints.bottomCenter.x,
            y2: childnode.touchPoints.bottomCenter.y,
            distance: this.getDistance(
              touchPoint.rightCenter.x,
              touchPoint.rightCenter.y,
              childnode.touchPoints.bottomCenter.x,
              childnode.touchPoints.bottomCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: childId,
            x1: touchPoint.rightCenter.x,
            y1: touchPoint.rightCenter.y,
            x2: childnode.touchPoints.leftCenter.x,
            y2: childnode.touchPoints.leftCenter.y,
            distance: this.getDistance(
              touchPoint.rightCenter.x,
              touchPoint.rightCenter.y,
              childnode.touchPoints.leftCenter.x,
              childnode.touchPoints.leftCenter.y
            ),
          });

          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: childId,
            x1: touchPoint.bottomCenter.x,
            y1: touchPoint.bottomCenter.y,
            x2: childnode.touchPoints.topCenter.x,
            y2: childnode.touchPoints.topCenter.y,
            distance: this.getDistance(
              touchPoint.bottomCenter.x,
              touchPoint.bottomCenter.y,
              childnode.touchPoints.topCenter.x,
              childnode.touchPoints.topCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: childId,
            x1: touchPoint.bottomCenter.x,
            y1: touchPoint.bottomCenter.y,
            x2: childnode.touchPoints.rightCenter.x,
            y2: childnode.touchPoints.rightCenter.y,
            distance: this.getDistance(
              touchPoint.bottomCenter.x,
              touchPoint.bottomCenter.y,
              childnode.touchPoints.rightCenter.x,
              childnode.touchPoints.rightCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: childId,
            x1: touchPoint.bottomCenter.x,
            y1: touchPoint.bottomCenter.y,
            x2: childnode.touchPoints.bottomCenter.x,
            y2: childnode.touchPoints.bottomCenter.y,
            distance: this.getDistance(
              touchPoint.bottomCenter.x,
              touchPoint.bottomCenter.y,
              childnode.touchPoints.bottomCenter.x,
              childnode.touchPoints.bottomCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: childId,
            x1: touchPoint.bottomCenter.x,
            y1: touchPoint.bottomCenter.y,
            x2: childnode.touchPoints.leftCenter.x,
            y2: childnode.touchPoints.leftCenter.y,
            distance: this.getDistance(
              touchPoint.bottomCenter.x,
              touchPoint.bottomCenter.y,
              childnode.touchPoints.leftCenter.x,
              childnode.touchPoints.leftCenter.y
            ),
          });

          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: childId,
            x1: touchPoint.leftCenter.x,
            y1: touchPoint.leftCenter.y,
            x2: childnode.touchPoints.topCenter.x,
            y2: childnode.touchPoints.topCenter.y,
            distance: this.getDistance(
              touchPoint.leftCenter.x,
              touchPoint.leftCenter.y,
              childnode.touchPoints.topCenter.x,
              childnode.touchPoints.topCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: childId,
            x1: touchPoint.leftCenter.x,
            y1: touchPoint.leftCenter.y,
            x2: childnode.touchPoints.rightCenter.x,
            y2: childnode.touchPoints.rightCenter.y,
            distance: this.getDistance(
              touchPoint.leftCenter.x,
              touchPoint.leftCenter.y,
              childnode.touchPoints.rightCenter.x,
              childnode.touchPoints.rightCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: childId,
            x1: touchPoint.leftCenter.x,
            y1: touchPoint.leftCenter.y,
            x2: childnode.touchPoints.bottomCenter.x,
            y2: childnode.touchPoints.bottomCenter.y,
            distance: this.getDistance(
              touchPoint.leftCenter.x,
              touchPoint.leftCenter.y,
              childnode.touchPoints.bottomCenter.x,
              childnode.touchPoints.bottomCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: childId,
            x1: touchPoint.leftCenter.x,
            y1: touchPoint.leftCenter.y,
            x2: childnode.touchPoints.leftCenter.x,
            y2: childnode.touchPoints.leftCenter.y,
            distance: this.getDistance(
              touchPoint.leftCenter.x,
              touchPoint.leftCenter.y,
              childnode.touchPoints.leftCenter.x,
              childnode.touchPoints.leftCenter.y
            ),
          });
        }
      });
    }

    if (parentIds.length > 0) {
      parentIds.forEach((parentId: any) => {
        let parentnode = this.nodes.find((m: any) => m.nodeId == parentId);
        if (parentnode) {
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: parentId,
            x1: touchPoint.topCenter.x,
            y1: touchPoint.topCenter.y,
            x2: parentnode.touchPoints.topCenter.x,
            y2: parentnode.touchPoints.topCenter.y,
            distance: this.getDistance(
              touchPoint.topCenter.x,
              touchPoint.topCenter.y,
              parentnode.touchPoints.topCenter.x,
              parentnode.touchPoints.topCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: parentId,
            x1: touchPoint.topCenter.x,
            y1: touchPoint.topCenter.y,
            x2: parentnode.touchPoints.rightCenter.x,
            y2: parentnode.touchPoints.rightCenter.y,
            distance: this.getDistance(
              touchPoint.topCenter.x,
              touchPoint.topCenter.y,
              parentnode.touchPoints.rightCenter.x,
              parentnode.touchPoints.rightCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: parentId,
            x1: touchPoint.topCenter.x,
            y1: touchPoint.topCenter.y,
            x2: parentnode.touchPoints.bottomCenter.x,
            y2: parentnode.touchPoints.bottomCenter.y,
            distance: this.getDistance(
              touchPoint.topCenter.x,
              touchPoint.topCenter.y,
              parentnode.touchPoints.bottomCenter.x,
              parentnode.touchPoints.bottomCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: parentId,
            x1: touchPoint.topCenter.x,
            y1: touchPoint.topCenter.y,
            x2: parentnode.touchPoints.leftCenter.x,
            y2: parentnode.touchPoints.leftCenter.y,
            distance: this.getDistance(
              touchPoint.topCenter.x,
              touchPoint.topCenter.y,
              parentnode.touchPoints.leftCenter.x,
              parentnode.touchPoints.leftCenter.y
            ),
          });

          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: parentId,
            x1: touchPoint.rightCenter.x,
            y1: touchPoint.rightCenter.y,
            x2: parentnode.touchPoints.topCenter.x,
            y2: parentnode.touchPoints.topCenter.y,
            distance: this.getDistance(
              touchPoint.rightCenter.x,
              touchPoint.rightCenter.y,
              parentnode.touchPoints.topCenter.x,
              parentnode.touchPoints.topCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: parentId,
            x1: touchPoint.rightCenter.x,
            y1: touchPoint.rightCenter.y,
            x2: parentnode.touchPoints.rightCenter.x,
            y2: parentnode.touchPoints.rightCenter.y,
            distance: this.getDistance(
              touchPoint.rightCenter.x,
              touchPoint.rightCenter.y,
              parentnode.touchPoints.rightCenter.x,
              parentnode.touchPoints.rightCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: parentId,
            x1: touchPoint.rightCenter.x,
            y1: touchPoint.rightCenter.y,
            x2: parentnode.touchPoints.bottomCenter.x,
            y2: parentnode.touchPoints.bottomCenter.y,
            distance: this.getDistance(
              touchPoint.rightCenter.x,
              touchPoint.rightCenter.y,
              parentnode.touchPoints.bottomCenter.x,
              parentnode.touchPoints.bottomCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: parentId,
            x1: touchPoint.rightCenter.x,
            y1: touchPoint.rightCenter.y,
            x2: parentnode.touchPoints.leftCenter.x,
            y2: parentnode.touchPoints.leftCenter.y,
            distance: this.getDistance(
              touchPoint.rightCenter.x,
              touchPoint.rightCenter.y,
              parentnode.touchPoints.leftCenter.x,
              parentnode.touchPoints.leftCenter.y
            ),
          });

          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: parentId,
            x1: touchPoint.bottomCenter.x,
            y1: touchPoint.bottomCenter.y,
            x2: parentnode.touchPoints.topCenter.x,
            y2: parentnode.touchPoints.topCenter.y,
            distance: this.getDistance(
              touchPoint.bottomCenter.x,
              touchPoint.bottomCenter.y,
              parentnode.touchPoints.topCenter.x,
              parentnode.touchPoints.topCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: parentId,
            x1: touchPoint.bottomCenter.x,
            y1: touchPoint.bottomCenter.y,
            x2: parentnode.touchPoints.rightCenter.x,
            y2: parentnode.touchPoints.rightCenter.y,
            distance: this.getDistance(
              touchPoint.bottomCenter.x,
              touchPoint.bottomCenter.y,
              parentnode.touchPoints.rightCenter.x,
              parentnode.touchPoints.rightCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: parentId,
            x1: touchPoint.bottomCenter.x,
            y1: touchPoint.bottomCenter.y,
            x2: parentnode.touchPoints.bottomCenter.x,
            y2: parentnode.touchPoints.bottomCenter.y,
            distance: this.getDistance(
              touchPoint.bottomCenter.x,
              touchPoint.bottomCenter.y,
              parentnode.touchPoints.bottomCenter.x,
              parentnode.touchPoints.bottomCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: parentId,
            x1: touchPoint.bottomCenter.x,
            y1: touchPoint.bottomCenter.y,
            x2: parentnode.touchPoints.leftCenter.x,
            y2: parentnode.touchPoints.leftCenter.y,
            distance: this.getDistance(
              touchPoint.bottomCenter.x,
              touchPoint.bottomCenter.y,
              parentnode.touchPoints.leftCenter.x,
              parentnode.touchPoints.leftCenter.y
            ),
          });

          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: parentId,
            x1: touchPoint.leftCenter.x,
            y1: touchPoint.leftCenter.y,
            x2: parentnode.touchPoints.topCenter.x,
            y2: parentnode.touchPoints.topCenter.y,
            distance: this.getDistance(
              touchPoint.leftCenter.x,
              touchPoint.leftCenter.y,
              parentnode.touchPoints.topCenter.x,
              parentnode.touchPoints.topCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: parentId,
            x1: touchPoint.leftCenter.x,
            y1: touchPoint.leftCenter.y,
            x2: parentnode.touchPoints.rightCenter.x,
            y2: parentnode.touchPoints.rightCenter.y,
            distance: this.getDistance(
              touchPoint.leftCenter.x,
              touchPoint.leftCenter.y,
              parentnode.touchPoints.rightCenter.x,
              parentnode.touchPoints.rightCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: parentId,
            x1: touchPoint.leftCenter.x,
            y1: touchPoint.leftCenter.y,
            x2: parentnode.touchPoints.bottomCenter.x,
            y2: parentnode.touchPoints.bottomCenter.y,
            distance: this.getDistance(
              touchPoint.leftCenter.x,
              touchPoint.leftCenter.y,
              parentnode.touchPoints.bottomCenter.x,
              parentnode.touchPoints.bottomCenter.y
            ),
          });
          res.push({
            currentnodeId: currentnode.nodeId,
            childnodeId: parentId,
            x1: touchPoint.leftCenter.x,
            y1: touchPoint.leftCenter.y,
            x2: parentnode.touchPoints.leftCenter.x,
            y2: parentnode.touchPoints.leftCenter.y,
            distance: this.getDistance(
              touchPoint.leftCenter.x,
              touchPoint.leftCenter.y,
              parentnode.touchPoints.leftCenter.x,
              parentnode.touchPoints.leftCenter.y
            ),
          });
        }
      });
    }

    return res;
  }
}
